import { Grid } from '@material-ui/core';
import React from 'react';


export default class InterpretareComponent2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

        

            this.interpretare(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2)
        
    }

    interpretare = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 < 0) {
                this.props.displayArrow('arrow1')
            } else {
                this.props.displayArrow('arrow2')
            } 
        }
    }


   


    render() {
        return (

            <Grid container>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{
                        width: '100%',
                        backgroundColor: 'rgb(227 51 59)',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: 12,
                        borderTopLeftRadius: 20,
                        borderBottomLeftRadius: 20,
                        position: 'relative',
                        padding: 5
                    }}>
                        {this.props.arrow1 &&
                            <i
                                style={{
                                    color: 'black',
                                    fontSize: 30,
                                    position: 'absolute',
                                    top: -23,
                                    left: 0,
                                    right: 0,
                                    margin: 'auto'
                                }}
                                className='material-icons'>arrow_drop_down</i>
                        }

                        {this.props.labels[0]}
                    </div>
                </Grid>
               
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{
                        width: '100%',
                        backgroundColor: 'rgb(86 133 26)',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: 12,
                        borderTopRightRadius: 20,
                        borderBottomRightRadius: 20,
                        position: 'relative',
                        padding: 5
                    }}>
                        {this.props.arrow2 &&
                            <i
                                style={{
                                    color: 'black',
                                    fontSize: 30,
                                    position: 'absolute',
                                    top: -23,
                                    left: 0,
                                    right: 0,
                                    margin: 'auto'
                                }}
                                className='material-icons'>arrow_drop_down</i>
                        }

                        {this.props.labels[1]}
                    </div>
                </Grid>
            </Grid>

        );
    }
}





